/* efx-of-companion.js — the cfg-simple order form's companion.
 *   §R9-H8  the two events the sticky order bar listens to
 *   §R9-H10 three decision rows in place of two dependent selects
 *   §R9-H13 the six events this flow has never produced
 *
 * WHAT THIS FILE MAY NOT DO. It never prices anything, never touches a
 * surcharge variant id and never posts to /cart/add.js. It writes
 * `select.value` and dispatches a real `change`, which is byte-for-byte the
 * mechanism R8-G20 already proved on the fraction chips (typed vs chips gave an
 * identical parse and an identical surcharge variant). The two selects stay in
 * the DOM as the source of truth; assets/ef-orderform-simple.js remains the
 * only thing that knows what a size costs.
 */
(function () {
  'use strict';

  var root = document.getElementById('efOf');
  if (!root) return;

  var widthSel  = document.getElementById('efOfSimpleWidth');
  var heightSel = document.getElementById('efOfSimpleHeight');
  var totalAmt  = document.getElementById('efOfTotalAmt');
  var fieldset  = document.getElementById('efOfSize');
  if (!widthSel || !heightSel) return;

  var CFG_TYPE = 'cfg-simple';

  /* ─────────────────────────── §R9-H8 — the bar ─────────────────────────── */

  function sizeChosen() { return root.getAttribute('data-size-unavailable') !== 'true' && !!(widthSel.value && heightSel.value); }

  /* `#efOfTotalAmt` is the receipt line the buyer reads, so it is also the
     number the bar echoes — anything else could disagree with it on screen. */
  function totalCents() {
    if (!totalAmt) return null;
    var t = (totalAmt.textContent || '').replace(/[^0-9.]/g, '');
    if (!t) return null;
    var n = Math.round(parseFloat(t) * 100);
    return isFinite(n) ? n : null;
  }

  function dispatch() {
    var done = sizeChosen();
    try {
      window.dispatchEvent(new CustomEvent('ef-cfg:state-changed', {
        detail: {
          cfgType: CFG_TYPE,
          totalSteps: 1,
          totalSkipped: 0,
          curStep: done ? 1 : 0,
          allSelectionsMade: done,
          isLast: true,   /* a one-page flow is always on its own last page */
        },
      }));
    } catch (e) {}
    var c = totalCents();
    if (c != null) {
      try { window.dispatchEvent(new CustomEvent('ef-cfg:price-changed', { detail: { totalCents: c, allSelectionsMade: done } })); } catch (e) {}
    }
  }

  /* ──────────────────── §R9-H10 — the decision rows ────────────────────────

     Q101 asked why Ardmore's Height select offers one option while Width
     offers three. It is not a catalogue gap: `simple_height` is a 2-D array
     indexed by the width choice (ef-orderform-simple.js :115-138), so Height
     holds a placeholder until Width is answered — and it was never `disabled`
     at rest, so a first-time buyer tapped a dead control and concluded the
     page was broken. `tierFor()` names the entire universe: THREE doors.

     Three outcomes presented as two dependent dropdowns is the defect. These
     rows are the three outcomes, one column, each carrying the four things a
     novice needs: the tier word, the opening it fits, the door it produces and
     the money.

     EVERY STRING AND EVERY PRICE IS READ FROM `EF_CFG_DATA`, never typed here.
     ROUND-9-SPEC §8 rows 2-3 quote Ardmore's ranges as 24-30" / 25-29" and its
     upgrades as +$74 / +$124; the served data says 30"-37" / 22 1/2"-29 1/2"
     and, on Camden, Colt, Farnsworth and Finley, +$75 / +$25. Hard-coding the
     spec's illustrative copy would put a wrong price on four of the seven
     products, so the copy pattern ships and the numbers come from the data. */

  var TIER_WORD = { S: 'Standard', L: 'Tall', XL: 'Wide' };

  function money(d) {
    var n = Number(d) || 0;
    return '$' + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toFixed(2));
  }

  function tierOf(wi, hi) {
    var f = window._efOfState && window._efOfState.tier;
    if (typeof f === 'function') return f(wi, hi);
    /* mirrors tierFor() only as a last resort; the engine's own copy is used
       whenever it is there */
    if (wi === 1) return 'XL';
    if (wi === 0 && hi === 1) return 'L';
    return 'S';
  }

  function combos(group) {
    var widths = group.simple_width || [];
    var heights = group.simple_height || [];
    var models = group.simple_models || [];
    var out = [];
    widths.forEach(function (w, wi) {
      var hs = heights[wi] || [];
      hs.forEach(function (h, hi) {
        out.push({
          wi: wi, hi: hi, w: w, h: h,
          model: (models[wi] || [])[hi] || null,
          surcharge: (w.price || 0) + (h.price || 0),
          tier: tierOf(wi, hi),
        });
      });
    });
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var rowsWrap = null;

  function renderRows(group) {
    // Copied standard-door page uses native dependent width and height selects.
    if (root.closest(".ef-lab-standard-doors")) return;
    if (!fieldset || rowsWrap) return;
    var list = combos(group);
    if (list.length < 2) return;   /* one outcome is not a decision */

    var q = el('p', 'ef-of-size__q', 'Which opening do you have?');
    q.id = 'efOfSizeQ';

    rowsWrap = el('div', 'ef-of-size__rows');
    rowsWrap.id = 'efOfSizeRows';
    rowsWrap.setAttribute('role', 'radiogroup');
    rowsWrap.setAttribute('aria-labelledby', 'efOfSizeQ');

    list.forEach(function (c, i) {
      var b = el('button', 'ef-of-size__row');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.tabIndex = i === 0 ? 0 : -1;
      b.dataset.wi = c.wi;
      b.dataset.hi = c.hi;
      b.dataset.tier = c.tier;

      var head = el('span', 'ef-of-size__head');
      head.appendChild(el('span', 'ef-of-size__tier', TIER_WORD[c.tier] || c.tier));
      head.appendChild(el('span', 'ef-of-size__money', c.surcharge > 0 ? '+' + money(c.surcharge) : 'included'));
      b.appendChild(head);

      b.appendChild(el('span', 'ef-of-size__fit',
        'Fits openings ' + c.w.label + ' wide × ' + c.h.label + ' tall'));

      if (c.model && (c.model.overall || c.model.name)) {
        b.appendChild(el('span', 'ef-of-size__door',
          c.model.overall ? ('Door ' + c.model.overall) : c.model.name));
      }

      /* The tick is ALWAYS in the box and only its opacity changes, so a
         selected row and an unselected row are the same height to the
         hundredth of a pixel (R9-G10, the T7-S contract). Selection is drawn
         with an inset box-shadow for the same reason: a border would move the
         content by its own width. */
      var tick = el('span', 'ef-of-size__tick');
      tick.setAttribute('aria-hidden', 'true');
      tick.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      b.appendChild(tick);

      b.addEventListener('click', function () { choose(b); });
      b.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowRight' && k !== 'ArrowLeft') return;
        e.preventDefault();
        var all = [].slice.call(rowsWrap.querySelectorAll('.ef-of-size__row'));
        var at = all.indexOf(b);
        var next = all[(at + (k === 'ArrowDown' || k === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
        if (next) { next.focus(); choose(next); }
      });

      rowsWrap.appendChild(b);
    });

    var sizes = fieldset.querySelector('.ef-of-simple__sizes');
    if (sizes) fieldset.insertBefore(q, sizes);
    else fieldset.appendChild(q);
    if (sizes) fieldset.insertBefore(rowsWrap, sizes);
    else fieldset.appendChild(rowsWrap);

    /* Only now do the selects step back: until the rows are on the page the
       selects ARE the interface, so an async script that never arrives leaves a
       working form rather than an empty gap. */
    root.setAttribute('data-sizeui', 'rows');
  }

  function choose(row) {
    var wi = row.dataset.wi, hi = row.dataset.hi;
    var wOpt = widthSel.querySelector('option[data-idx="' + wi + '"]');
    if (!wOpt) return;
    /* WIDTH FIRST, THEN HEIGHT, SYNCHRONOUSLY. onWidthChange() rebuilds the
       height list from `simple_height[widthIdx]`, so a height written before
       the width would be written into the previous width's list. */
    widthSel.value = wOpt.value;
    widthSel.dispatchEvent(new Event('change', { bubbles: true }));
    var hOpt = heightSel.querySelector('option[data-idx="' + hi + '"]');
    if (hOpt) {
      heightSel.value = hOpt.value;
      heightSel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncRows();
    writeEcho();
    dispatch();
  }

  /* §R9-H11 — THE OPENING ECHO. `#efOfSimpleOverall` describes the DOOR; this
     reads the OPENING back to the buyer in the same words the row used, right
     above the money. It is written from the SELECTED OPTIONS, not from the row,
     so it is identical whether the buyer used a row (767 and below) or the two
     selects (768 and up), and it cannot drift from what is being priced. */
  var echoEl = document.getElementById('efOfEcho');
  function writeEcho() {
    if (!echoEl) return;
    var w = widthSel.value, h = heightSel.value;
    if (!w || !h) { echoEl.hidden = true; echoEl.textContent = ''; return; }
    echoEl.textContent = '';
    var lbl = document.createElement('b');
    lbl.textContent = 'Your opening: ';
    echoEl.appendChild(lbl);
    echoEl.appendChild(document.createTextNode(w + ' wide × ' + h + ' tall'));
    echoEl.hidden = false;
  }
  function syncRows() {
    if (!rowsWrap) return;
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var hOpt = heightSel.options[heightSel.selectedIndex];
    var wi = wOpt && wOpt.dataset.idx != null ? String(wOpt.dataset.idx) : null;
    var hi = hOpt && hOpt.dataset.idx != null ? String(hOpt.dataset.idx) : null;
    [].forEach.call(rowsWrap.querySelectorAll('.ef-of-size__row'), function (b) {
      var on = wi !== null && hi !== null && b.dataset.wi === wi && b.dataset.hi === hi;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-selected', on);
      b.tabIndex = on ? 0 : -1;
    });
    if (!rowsWrap.querySelector('.ef-of-size__row[tabindex="0"]')) {
      var first = rowsWrap.querySelector('.ef-of-size__row');
      if (first) first.tabIndex = 0;
    }
  }

  /* ─────────────────────────────── boot ─────────────────────────────────── */

  widthSel.addEventListener('change', function () { syncRows(); writeEcho(); dispatch(); });
  heightSel.addEventListener('change', function () { syncRows(); writeEcho(); dispatch(); });

  /* The engine rewrites `#efOfTotalAmt` inside recomputeTotal() without firing
     anything. Watching the node is cheaper than re-deriving the price here, and
     it keeps this file incapable of disagreeing with the receipt. */
  if (totalAmt && window.MutationObserver) {
    try { new MutationObserver(dispatch).observe(totalAmt, { childList: true, characterData: true, subtree: true }); } catch (e) {}
  }

  function tryRows() {
    var g = window._efOfState && window._efOfState.group;
    if (g) { renderRows(g); syncRows(); writeEcho(); dispatch(); return true; }
    return false;
  }
  document.addEventListener('ef-of:ready', tryRows);
  if (!tryRows()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (tryRows() || ++tries > 120) clearInterval(iv);   /* 12 s ceiling */
    }, 100);
  }


  /* ───────────────────── §R9-H13 — instrumentation ─────────────────────────

     MEASURED BEFORE (R8 board, pdp_doors_simple @390): all eight G27 rows read
     `dataLayer=false gtag=false cfg_type+device=null`. ef-orderform-simple.js
     pushes nothing, ever. 26 % of mobile door revenue produced ZERO events, so
     no read in the measurement plan could include this flow and no test on it
     could be judged.

     Six pushes, through the pipe that already exists: snippets/efx-analytics-
     forward.liquid decorates every `ef_*` push in place and forwards only the
     UNPAIRED ones to gtag, so there is no new pipe and no double-send. This
     file sets `cfg_type` itself because the forward reads it from
     `#efCfg[data-cfg-type]`, and a cfg-simple page has no `#efCfg` — that is
     the route, not a defect (ef-configurator-v2.js :61-62).

     NOTHING FIRES ON LOAD. `ef_of_view` is an IntersectionObserver on `#efOf`
     at 50 %, because the form starts 2,118 px down the page: an event that
     fired at load would be counting page views, not form views, and R9-G19
     asks for 0 at load precisely so that cannot be smuggled in. */

  var DEVICE = (function () {
    try { return window.matchMedia('(max-width: 1023px)').matches ? 'mobile' : 'desktop'; }
    catch (e) { return 'unknown'; }
  }());

  function track(name, params) {
    var p = {};
    if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    p.event = name;
    p.cfg_type = CFG_TYPE;
    p.device = DEVICE;
    try { if (root.dataset.productHandle) p.product_handle = root.dataset.productHandle; } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
  }

  function selectedTier() {
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var hOpt = heightSel.options[heightSel.selectedIndex];
    var wi = wOpt && wOpt.dataset.idx != null ? parseInt(wOpt.dataset.idx, 10) : -1;
    var hi = hOpt && hOpt.dataset.idx != null ? parseInt(hOpt.dataset.idx, 10) : -1;
    if (wi < 0 || hi < 0) return null;
    return tierOf(wi, hi);
  }

  /* 1 — the form was actually seen */
  if (window.IntersectionObserver) {
    try {
      var seenOnce = false;
      /* MEASURED: a 0.5 RATIO threshold did not fire at 375 x 812.  is
         about 1,383 px tall, so half of it is 692 px and the ratio depends on the
         viewport height — the shortest phone is the one that would miss the event,
         which is exactly backwards. The condition is now an ABSOLUTE band of the
         form on screen, which behaves the same at 375 and at 430. */
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (seenOnce || !e.isIntersecting) continue;
          var seenPx = e.intersectionRect ? e.intersectionRect.height : 0;
          var wholeThing = e.boundingClientRect && e.boundingClientRect.height <= seenPx + 1;
          if (seenPx >= 240 || wholeThing) {
            seenOnce = true;
            track('ef_of_view', {});
            io.disconnect();
          }
        }
      }, { threshold: [0, 0.05, 0.25, 0.5] });
      io.observe(root);
    } catch (e) {}
  }

  /* 2 — a size was chosen, by either control */
  var lastTracked = null;
  function trackSize() {
    if (!sizeChosen()) return;
    var t = selectedTier();
    var key = widthSel.value + '|' + heightSel.value;
    if (key === lastTracked) return;
    lastTracked = key;
    track('ef_of_size_select', {
      size_tier: t,
      opening_width: widthSel.value,
      opening_height: heightSel.value,
      ui: root.getAttribute('data-sizeui') === 'rows' ? 'row' : 'select',
      value_cents: totalCents(),
    });
  }
  widthSel.addEventListener('change', trackSize);
  heightSel.addEventListener('change', trackSize);

  /* 3 — a photo was attached. The photo IS the fit check on this tier, so it is
         the one non-size interaction worth a name. */
  var fileEl = document.getElementById('efOfFile');
  if (fileEl) {
    fileEl.addEventListener('change', function () {
      if (fileEl.files && fileEl.files.length) track('ef_of_photo_add', {});
    });
  }

  /* 4 — the human escape was taken (§R9-H12) */
  var callRow = root.querySelector('.ef-of__callrow');
  if (callRow) callRow.addEventListener('click', function () { track('ef_of_call_click', { placement: 'form' }); });

  /* 5 and 6 — the two commits. CAPTURE phase, so the event is recorded before
     the engine's own handler can navigate away on the express path. */
  var atcEl = document.getElementById('efOfAtc');
  if (atcEl) {
    atcEl.addEventListener('click', function () {
      track('ef_of_atc', { size_tier: selectedTier(), value_cents: totalCents(), via: 'form' });
    }, true);
  }
  var stickyEl = document.getElementById('efPd2StickyAtc');
  if (stickyEl) {
    stickyEl.addEventListener('click', function () {
      var bar = document.getElementById('efPd2Sticky');
      if (!bar || bar.getAttribute('data-state') !== 'unlocked') return;   /* a locked tap is a scroll, not a commit */
      track('ef_of_atc', { size_tier: selectedTier(), value_cents: totalCents(), via: 'bar' });
    }, true);
  }
  var expressEl = document.getElementById('efOfExpressCheckout');
  if (expressEl) {
    expressEl.addEventListener('click', function () {
      track('ef_of_express_click', { size_tier: selectedTier(), value_cents: totalCents() });
    }, true);
  }

  /* ef-pd2-sticky-atc.js is `defer`; this file is `async`. Whichever wins the
     race, the bar must end up painted in the right state, so the opening state
     is announced more than once rather than exactly once. */
  dispatch();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dispatch);
  window.addEventListener('load', dispatch);
  setTimeout(dispatch, 400);
  setTimeout(dispatch, 1600);
})();
